import { Controller, useWatch } from "react-hook-form";
import { useAliasVerification } from "../shared/useAliasVerification";
import { paybillValidators } from "../validations/lipaBidhaaValidations";
import { AliasInputField } from "./shared/AliasInputField";
import { AmountField } from "./shared/AmountField";
import { NextReviewButton } from "./shared/NextReviewButton";
import CustomTextInput from "../../ui/CustomTextInput/CustomTextInput";
import useLipaBidhaaStore from "../../../stores/lipaBidhaaStore";

export function PaybillFields({
  control,
  onNext,
  isLoading,
  walletBalance,
  isBalanceError,
}) {
  const { handleAliasChange, handleAliasBlur, isVerifying, isVerified } = useAliasVerification();
  const amount = useWatch({ control, name: "amount" });
  const accountNumber = useWatch({ control, name: "accountNumber" });
  const hasAccountNumber = !!accountNumber?.trim();
  const canProceed = isVerified && hasAccountNumber && !!amount;

  const getTooltipLabel = () => {
    if (canProceed) return undefined;
    if (isVerified && hasAccountNumber) return "Enter an amount to continue";
    if (isVerified) return "Enter an account number to continue";
    return "Verify your paybill number to continue";
  };
  const tooltipLabel = getTooltipLabel();

  return (
    <div className="space-y-4">
      <AliasInputField
        control={control}
        aliasValidator={paybillValidators.alias}
        handleAliasChange={handleAliasChange}
        handleAliasBlur={handleAliasBlur}
        isVerifying={isVerifying}
        isLoading={isLoading}
      />

      <Controller
        name="accountNumber"
        control={control}
        rules={{ validate: (v) => paybillValidators.accountNumber(v) ?? true }}
        render={({ field, fieldState }) => (
          <CustomTextInput
            label="Account Number"
            placeholder="Enter account number"
            withAsterisk
            size="sm"
            disabled={isLoading}
            value={field.value}
            onChange={(e) => {
              field.onChange(e);
              useLipaBidhaaStore
                .getState()
                .setPaymentDraft({ accountNumber: e.target.value });
            }}
            onBlur={field.onBlur}
            error={fieldState.error?.message}
          />
        )}
      />

      <AmountField
        control={control}
        amountValidator={paybillValidators.amount}
        walletBalance={walletBalance}
        isBalanceError={isBalanceError}
        isLoading={isLoading}
      />

      <NextReviewButton
        onNext={onNext}
        isLoading={isLoading}
        canProceed={canProceed}
        tooltipLabel={tooltipLabel}
      />
    </div>
  );
}
